import { CSSProperties, FC } from 'react';
import styled from 'styled-components';

import './styles.css';

export const GameWidgetWrapper: FC<{ style: CSSProperties }> = ({ children, style }) => (
  <GameWidgetWrapperContainer className="game-widget-wrapper" style={style}>
    {children}
  </GameWidgetWrapperContainer>
);

export const GameFormWrapper: FC<{ className?: string }> = ({ children, className = '' }) => (
  <GameFormWrapperContainer className={`game-form-wrapper ${className}`}>{children}</GameFormWrapperContainer>
);

export const GameWidgetWrapperContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  min-height: 100%;
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  word-break: break-word;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

export const GameWrapper = styled.div`
  flex-shrink: 0;
`;

export const GameFormWrapperContainer = styled.div`
  width: 100%;
  padding: 0 10px 32px;

  @media screen and (min-width: 768px) {
    padding: 80px 16px 40px;
  }
`;
